import { PartialNullable } from "../../../types";
import { DraftAlbum, RegionSettings, TrackRelease, TrackReleaseSet } from "../../../api/useMusicApi";
import { UpdateFields } from "../../../hooks/use-advanced-state";
import React from "react";
import { Input } from "../../../components/Input";
import { useTranslation } from "../../../hooks/useTranslation";
import { ValidationError, ValidationInputWrapper } from "../../../components/ValidationInputWrapper";
import { CopyFieldValueButton } from "../../../components/CopyFieldValueButton";

type Props = {
  entity?: PartialNullable<DraftAlbum | TrackRelease | TrackReleaseSet>;
  disabled?: boolean;
  onChange: UpdateFields<DraftAlbum | TrackRelease | TrackReleaseSet>;
  regionSettings: RegionSettings;
  validationErrorPrefix?: string;
  validationErrors?: ValidationError[];
  onChangeForAll?: (field: keyof TrackReleaseSet | string, value?: any) => void;
};

export function isAlbum(
  entity: PartialNullable<DraftAlbum | TrackRelease | TrackReleaseSet>
) {
  return "content_type" in entity;
}

export const EditDraftFormLocalizedTitlePart: React.FC<Props> = ({
                                                                   entity,
                                                                   validationErrors = [],
                                                                   validationErrorPrefix,
                                                                   disabled,
                                                                   regionSettings,
                                                                   onChange,
                                                                   onChangeForAll
                                                                 }) => {
  const { t } = useTranslation();
  return (
    <div className={"flex gap-3 w-full"}>
      <div className={"flex-1"}>
        <ValidationInputWrapper
          attribute={`${
            validationErrorPrefix ? `${validationErrorPrefix}.` : ""
          }country_meta.title.${regionSettings}`}
          validationErrors={validationErrors}
        >
          <Input
            disabled={disabled}
            validationError={
              validationErrors?.find(
                (e) =>
                  e.attr ===
                  `${
                    validationErrorPrefix ? `${validationErrorPrefix}.` : ""
                  }country_meta.title.${regionSettings}`
              )?.detail
            }
            required={true}
            label={`${t("title_release")}`}
            defaultValue={entity?.country_meta?.title?.[regionSettings] ?? ""}
            placeholder={t("title_release_placeholder").toString()}
            containerClassName={"flex-1"}
            className={"my-1"}
            onChange={(value) =>
              onChange((prevState) => {
                return {
                  ...prevState,
                  country_meta: {
                    ...(prevState.country_meta ?? {}),
                    title: {
                      ...(prevState.country_meta?.title ?? {}),
                      [regionSettings]: value ?? null
                    }
                  }
                } as any;
              })
            }
          />
        </ValidationInputWrapper>
      </div>

      <div className={"flex-1"}>
        <ValidationInputWrapper
          attribute={`${
            validationErrorPrefix ? `${validationErrorPrefix}.` : ""
          }country_meta.subtitle.${regionSettings}`}
          validationErrors={validationErrors}
        >
          <Input
            disabled={disabled}
            required={false}
            label={`${t("subtitle_release")}`}
            labelHint={t("subtitle_release_hint").toString()}
            containerClassName={"flex-1"}
            className={"my-1"}
            labelAdditionalContent={
              <CopyFieldValueButton
                visible={!isAlbum(entity ?? {}) && !(disabled ?? false)}
                fieldPath={`country_meta.subtitle`}
                onChangeForAll={onChangeForAll ?? null}
              />
            }
            defaultValue={
              entity?.country_meta?.subtitle?.[regionSettings] ?? ""
            }
            validationError={
              validationErrors?.find(
                (e) =>
                  e.attr ===
                  `${
                    validationErrorPrefix ? `${validationErrorPrefix}.` : ""
                  }country_meta.subtitle.${regionSettings}`
              )?.detail
            }
            placeholder={t("subtitle_release_placeholder").toString()}
            onChange={(value) =>
              onChange((prevState) => {
                return {
                  ...prevState,
                  country_meta: {
                    ...(prevState.country_meta ?? {}),
                    subtitle: {
                      ...(prevState.country_meta?.subtitle ?? {}),
                      [regionSettings]: value ?? null
                    }
                  }
                } as any;
              })
            }
          />
        </ValidationInputWrapper>
      </div>

    </div>
  );
};
